import { Sparkles } from "lucide-react"
import type { FloatingTabPillTab } from "@/components/ui/floating-tab-pill"
import { cn } from "@/lib/utils"

const ASSISTANT_TAB_ICON_CLASS = "h-3.5 w-3.5"

/**
 * Sparkles on every Assistant pill tab; a spinner while the agent run is streaming.
 * The spinner goes through `busy`, so it shows even where the icon is hidden next to the label
 * (`iconWhenCollapsedOnly` — shot dock, canvas).
 */
export function decorateAssistantTabs(tabs: FloatingTabPillTab[], busy: boolean): FloatingTabPillTab[] {
  return tabs.map((tab) => {
    if (tab.id !== "assistant") return tab
    return {
      ...tab,
      busy: Boolean(tab.busy) || busy,
      iconWhenCollapsedOnly: tab.iconWhenCollapsedOnly === true,
      icon: <Sparkles className={cn(ASSISTANT_TAB_ICON_CLASS, !tab.active && "text-ui-accent")} />,
    }
  })
}
